import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ItemCategory } from '../../models/item/item-master/item-master';

import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class ItemCategoryProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/item-category';

  public getAllItemsCategories(): Observable<ApiResponse<ItemCategory[]>> {
    return this.httpClient.get<ApiResponse<ItemCategory[]>>(`${this.baseUrl}/all`);
  }
}
